import React, { useContext, useState, useEffect } from "react";
import styles from "./EventInstructions.module.css";
import { stringConstants } from "../../constants";
import { GetCMSDocument } from "../../APIManager";

import { ConfigContext } from "../../ConfigContext";

import { Skeleton, Divider, Typography } from "antd";

const { Title } = Typography;

export default function EventInstructions() {
  let [config, setConfig] = useContext(ConfigContext);
  const [isLoading, SetIsLoading] = useState(true);

  const [cmsEventInstructions, SetCMSEventInstructions] = useState("");

  useEffect(() => {
    GetCMSDocument("EventInstructionsPageInstructions").then((res) => {
      SetCMSEventInstructions(res?.data?.Data?.Instructions);
      SetIsLoading(false);
    });
  }, []);

  function ReplaceVariables(template) {
    return template.replace(
      /{stringConstants\.([\w]+)}/g, // Regex to match {stringConstants.PropertyName}
      (_, key) => config.cpConfig[key] || `{stringConstants.${key}}` // Replace with value or keep the placeholder if not found
    );
  }

  return (
    <div className={styles.MainContainer}>
      <Divider>
        {" "}
        <Title level={3}>Rules for Event Registration</Title>
      </Divider>
      <Skeleton loading={isLoading} paragraph={{ rows: 10 }} />
      <div
        dangerouslySetInnerHTML={{
          __html: ` ${ReplaceVariables(cmsEventInstructions)}`,
        }}
      />
    </div>
  );
}
